module.exports = __webpack_public_path__ + "img/female-bot.34000e08.png";